import { Component, Input } from '@angular/core';
import { HardwareScanTestResult } from 'src/app/modules/hardware-scan/enums/hardware-scan.enum';

@Component({
	selector: 'vtr-ui-hardware-list',
	templateUrl: './ui-hardware-list.component.html',
	styleUrls: ['./ui-hardware-list.component.scss'],
})
export class UiHardwareListComponent {
	@Input() componentId: string;
	@Input() items: Array<any>;
	@Input() template = 1;
	@Input() isListCollapsed = false;

	public testResultEnum: typeof HardwareScanTestResult;

	constructor() {
		this.testResultEnum = HardwareScanTestResult;
	}
}
